import { HostBinding, inject } from '@angular/core';
import { AppVisualContextService } from 'src/app/shared/services/app-visual-context.service';
import { AppAccent } from 'src/app/core/types/app-accent.type';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { FormHelper } from 'src/app/core/helpers/form.helper';
import { AuthService, UsuarioExternoResponse } from 'src/app/shared/services/auth.service';
import { PopupService } from 'src/app/shared/services/popup.service';

/**
 * Definição de senha do usuário externo a partir do link de uso único enviado por e-mail
 * (solicitado em CadastroUsuarioComponent). O token é validado somente pelo ws, no envio.
 */
@Component({
  selector: 'app-definir-senha',
  templateUrl: './definir-senha.component.html',
  styleUrls: ['../cadastro-usuario/cadastro-usuario.component.css'],
})
export class DefinirSenhaComponent implements OnInit {
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForAccent(this.accent);
  }

  accent: AppAccent = 'solicitacao';

  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  formSenha: FormGroup;
  token: string | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private popupService: PopupService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');

    this.formSenha = this.formBuilder.group({
      senha: ['', [Validators.required, Validators.minLength(6)]],
      confirmarSenha: ['', [Validators.required, FormHelper.senhasConferemValidator()]],
    });

    // Reavalia a confirmação de senha quando a senha original é alterada depois dela.
    this.formSenha
      .get('senha')
      ?.valueChanges.subscribe(() => this.formSenha.get('confirmarSenha')?.updateValueAndValidity({ emitEvent: false }));
  }

  togglePassword(): void {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPassword(): void {
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }

  submit(): void {
    if (!this.token) return;

    if (this.formSenha.invalid) {
      this.formSenha.markAllAsTouched();
      this.popupService.showError('Preencha corretamente a nova senha!');
      return;
    }

    const body = JSON.stringify({ token: this.token, senha: this.formSenha.value.senha });

    this.authService
      .definirSenhaExterno({ body, spinnerDelay: 300 })
      .pipe(take(1))
      .subscribe({
        // Endpoint do módulo Externo do ws: envelope { error, message }, diferente do SgrResponse padrão do SGR.
        next: (response: UsuarioExternoResponse) => {
          if (response.error) {
            this.popupService.showError(response.message || 'Falha ao definir a senha!');
            return;
          }
          this.popupService.showSuccess(response.message || 'Senha definida com sucesso! Faça login para continuar.');
          this.router.navigateByUrl('/login', { replaceUrl: true });
        },
        error: (response: { error?: UsuarioExternoResponse }) => {
          this.popupService.showError(response?.error?.message || 'Falha ao definir a senha!');
        },
      });
  }
}
